import { PetLinkAutoOrder } from '@/types/PetLinkAutoOrders';
import { ComparisonProduct } from '@/types/PetLinkComparison';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PetLinkSlice = {
  comparisonData: ComparisonProduct[];
  ezShipData: PetLinkAutoOrder[];
};

const initialState = {
  comparisonData: [],
  ezShipData: [],
} as PetLinkSlice;

const petLink = createSlice({
  name: 'petLink',
  initialState,
  reducers: {
    setComparisonData(state, { payload: allProfiles }: PayloadAction<ComparisonProduct[]>) {
      state.comparisonData = allProfiles;
    },
    setEzShipData(state, { payload: allProfiles }: PayloadAction<PetLinkAutoOrder[]>) {
      state.ezShipData = allProfiles;
    },
  },
});

export const { setComparisonData, setEzShipData } = petLink.actions;
export default petLink;
